module.exports = __webpack_public_path__ + "img/qq.b6432515.png";